export const webRtcStatusReducer = (state) => {
  state.status = true;
};
